import { isYoutubeURL } from 'utils/validators';
import HelpFilled from 'assets/icons/HelpFilled';

interface InputWithLabelProps {
  label: string;
  tooltip?: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  type?: string;
  required?: boolean;
}

export default function InputWithLabel({
  label,
  tooltip,
  handleChange,
  value,
  type = 'URL',
  required = false
}: Readonly<InputWithLabelProps>) {
  const isUrlType = type.toLowerCase() === 'url';
  const isRequiredValuePresent = !required || Boolean(value.trim());
  const hasValidUrl = value.trim() === '' ? true : isYoutubeURL(value);

  const determineBorderColor = () => {
    const shouldShowRedBorder =
      !isRequiredValuePresent || (isUrlType && !hasValidUrl);

    return shouldShowRedBorder ? 'border border-red-400' : '';
  };

  return (
    <div className='flex flex-col'>
      <div className='flex z-10'>
        <h6 className='text-xs 2xl:text-sm 4xl:text-base pb-0.5 text-gray-600 dark:text-gray-400 font-semibold mr-2'>
          {label}
        </h6>
        {tooltip && (
          <div className='group relative'>
            <HelpFilled />
            <span className='rounded absolute hidden bg-black !text-white mt-1 p-1 group-hover:block w-56 text-xs'>
              <p className='!text-white'>{tooltip}</p>
            </span>
          </div>
        )}
      </div>
      <input
        className={`py-2 px-3 mb-2 rounded text-sm 2xl:text-base 4xl:text-lg font-semibold outline-none bg-white dark:bg-secondary-dark-200 text-gray-900 dark:text-secondary-dark-900 ${determineBorderColor()}`}
        type='text'
        value={value}
        onChange={handleChange}
      />
    </div>
  );
}
